module.exports = __webpack_public_path__ + "static/media/login.d818fb2f.jpg";